/** @format */

export enum TrustedShopsBadgeVariant {
    REVIEWS = 'reviews',

    DEFAULT = 'default',
    CUSTOM = 'custom',
    CUSTOM_REVIEWS = 'custom_reviews',
}

export enum TrustedShopsBadgeResponsiveVariant {
    FLOATING = 'floating',
    FLOATING_REVIEWS = 'floating-reviews',
    CUSTOM = 'custom',
}

export enum TrustCardDirection {
    TOP_RIGHT = 'topRight',
    TOP_LEFT = 'topLeft',
    BOTTOM_RIGHT = 'bottomRight',
    BOTTOM_LEFT = 'bottomLeft',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
interface TrustedShopsBadgeResponsiveConfig {
    variant: TrustedShopsBadgeResponsiveVariant;
    customElementId: string;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface TrustedShopsBadgeConfig {
    /* The visual variant to display */
    variant: TrustedShopsBadgeVariant;

    /**
     * The variant to display when in responsive mode;
     */
    responsive?: TrustedShopsBadgeResponsiveConfig | false;

    /**
     * The element to render the trust card in
     */
    customCheckoutElementId?: string;

    /* Required for variants custom and custom_reviews */
    customElementId: string;

    /* For custom variants: topRight, topLeft, bottomRight, bottomLeft */
    trustcardDirection: TrustCardDirection;

    /* for custom variants: 40 - 90 (in pixels) */
    customBadgeWidth?: string;

    /* For custom variants: 40 - 90 (in pixels) */
    customBadgeHeight?: string;

    /* Deactivate responsive behaviour */
    disableResponsive?: string;

    /* Deactivate trustbadge */
    disableTrustbadge?: string;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface WindowWithTrustedShops extends Window {
    _tsConfig?: TrustedShopsBadgeConfig;
    trustbadge?: {
        reInitialize: () => void;
        remove: () => void;
    };
}

function reInitialize(): void {
    (window as WindowWithTrustedShops)?.trustbadge?.reInitialize();
}

export const trustedShopsBadge = {
    reInitialize,
};
